import PropTypes from 'prop-types';
const Modal = ({ isOpen, onClose, children, title, activeclose=true }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 antialiased bg-gray-900/60 z-[9999] flex justify-center items-center  transition-opacity duration-300 ease-out">
            <div className="bg-light shadow-xl shadow-default border border-slate-200 rounded-md">      
              <div className="border-b border-default  pt-3 pb-2 px-1 mx-3 mb-0 flex justify-between">
                 <span className="text-[0.95rem] md:text-[0.99rem] font-semibold text-gray-600">
                   {title}
                 </span>
                 {activeclose &&(
                     <span className="text-gray-500 text-right hover:text-gray-700 flex justify-end cursor-pointer" onClick={onClose}>
                         &#x2715; {/* Close button */}
                     </span>)
                 }   
              </div>
              <div className="flex w-full rounded-lg shadow-lg pl-6 pr-6 pt-4 pb-4 bg-light">
                 {children}
              </div>
            </div>
        </div>
    );
};
Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired, 
  title: PropTypes.string.isRequired,
  activeclose: PropTypes.bool,
};


export default Modal;
